import { Inject } from 'vue-di-container';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Toaster } from '../../../Services/toast';
import RegulationsManagementService from '../RegulationsManagementService';
import WithRender from './AddRegulation.html';

@WithRender
@Component({
    diProvide: [RegulationsManagementService],
})
export default class AddRegulation extends Vue {
    @Inject(RegulationsManagementService) public regulationsService!: RegulationsManagementService;

    @Prop({ type: String, default: 'Add' })
    public mode!: string;

    @Prop({ default: '' })
    public id!: string;

    @Prop({ type: Boolean, default: false })
    public layoutSup!: boolean;

    public regulationsText: string = '';
    public aiPromptText: string = '';
    public category: number = 1;
    public status: number = 0;
    public isActiveLocked: boolean = false;

    public get isEditMode(): boolean {
        return this.mode === 'Edit';
    }

    public async mounted() {
        this.$emit('childinit', this.layoutSup);
        if (this.isEditMode && this.id) {
            const response = await this.regulationsService.getById(this.id);
            if (!response.isSuccess || !response.result) {
                Toaster.error(response.errorMessage || this.$t('shared.regulationLoadFailed').toString());
                this.$router.push({ name: 'RegulationsManagement' });
                return;
            }
            const r = response.result;
            this.regulationsText = r.regulations || '';
            this.aiPromptText = r.aiPrompt || '';
            this.category = r.category;
            this.status = r.status;
            this.isActiveLocked = r.status === 1;
        }
    }

    public get isValid(): boolean {
        return !!(this.regulationsText && this.regulationsText.trim());
    }

    public async save() {
        if (!this.isValid) {
            Toaster.error(this.$t('shared.regulationPoliciesRequired').toString());
            return;
        }
        if (this.isEditMode) {
            if (this.isActiveLocked) {
                Toaster.error(this.$t('shared.regulationCannotEditActive').toString());
                return;
            }
            const response = await this.regulationsService.update(this.id, {
                regulations: this.regulationsText,
                status: this.status,
            });
            if (response.isSuccess) {
                Toaster.success(this.$t('shared.regulationSaved').toString());
                this.$router.push({ name: 'RegulationsManagement' });
            } else {
                Toaster.error(response.errorMessage || this.$t('shared.regulationSaveFailed').toString());
            }
        } else {
            const response = await this.regulationsService.create({
                regulations: this.regulationsText,
                category: this.category,
                status: this.status,
            });
            if (response.isSuccess) {
                Toaster.success(this.$t('shared.addSuccessfully').toString());
                this.$router.push({ name: 'RegulationsManagement' });
            } else {
                Toaster.error(response.errorMessage || this.$t('shared.regulationSaveFailed').toString());
            }
        }
    }
}
